<template>
  <div class="footer black-background" layout="column top-center">
    <div>
      <ul >
        <li>
          <a href="https://www.smart.com/de/de/index/footer/data-protection.html" target="_blank">Datenschutz</a>
        </li>
        <li>
          <span>|</span>
        </li>
        <li>
          <a href="https://www.smart.com/de/de/index/footer/anbieter.html" target="_blank">Anbieter</a>
        </li>
        <li>
          <span>|</span>
        </li>
        <li>
          <router-link to="/teilnahmebedingungen">Teilnahmebedingungen</router-link>
        </li>
        <li>
          <span>|</span>
        </li>
        <li>
          <a href="https://www.smart.com/de/de/index/footer/rechtliche-hinweise.html" target="_blank">Rechtliche Hinweise</a>
        </li>
        <li>
          <span>|</span>
        </li>
        <li>
          <a href="https://www.smart.com/de/de/index/footer/cookies.html" target="_blank">Cookies</a>
        </li>
        <li>
          <span>|</span>
        </li>

        <li>
          <a href="https://www.smart.com/de/de/index/smart-dialog-center.html" target="_blank">Kontakt</a>
        </li>

        <li>
          <span>|</span>
        </li>

        <li>


          <div style="position: relative;">

            <transition name="fade">
              <div class="social-media-box" v-show="showBox">
                <a href="https://www.facebook.com/smart.germany/" target="_blank">
                  <div layout="row center-left" class="social-media">
                    <img src="/static/images/facebook.png" srcset="/static/images/facebook@2x.png"/>
                    <span>Facebook</span>
                  </div>
                </a>
                <a href=" https://www.instagram.com/smart_deutschland/" target="_blank">
                  <div layout="row center-left" class="social-media">
                    <img src="/static/images/instagram.png" srcset="/static/images/instagram@2x.png"/>
                    <span>Instagram</span>
                  </div>
                </a>
              </div>
            </transition>

            <a href="javascript:void(0);" @click="showTheBox(!showBox, $event)">Social Media</a>
          </div>
        </li>
        <br>
      </ul>

    </div>
  </div>
</template>

<script>
  export default {
    name: "smart-footer",
    data() {
      return {
        showBox: false
      }
    },
    methods: {
      showTheBox(value, event) {
        event.stopImmediatePropagation();
        if (value) {
          document.addEventListener('click', this._onClick);
        } else {
          document.removeEventListener('click', this._onClick);
        }

        this.showBox = value;
      }
    },
    mounted() {
      this._onClick = (e) => {
        if (this.showBox) this.showBox = false;
      };
    },
    destroyed() {
      this.showTheBox(false);
    }
  }
</script>

<style lang="scss" scoped>

  $color: #125C71;
  .footer {
    margin-top: 0rem;
    font-size: 0.9rem;
    font-weight: 100;
    color: $color;
    width: 100vw;

    overflow: visible;

    margin-bottom: 50px;
    padding-left: 0.5rem;
    padding-right: 0.5rem;

  }

  .footer a {
    text-decoration: none;
    color: $color;
  }

  .footer span {
    margin-left: 0.5rem;
    margin-right: 0.5rem;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  li {
    float: left;
    padding: 0;
  }

  .social-media {
    margin-bottom: 0.1rem;
    background-color: rgba(0, 159, 227, 0.2);
    cursor: pointer;
  }

  .social-media-box {
    position: absolute;
    bottom: 1.5rem;
    left: 0px;

    color: white;
    width: 10rem;
  }

  .social-media-box a {
    color: white;
  }

  .social-media-box img {
    width: 2.5rem;
  }

  .social-media-box span {
    margin-left: 1rem;
  }

  fade-enter-active, .fade-leave-active {
    transition: opacity .2s;
  }

  .fade-enter, .fade-leave-to {
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/SmartFooter.vue